<!-- //
窗体分隔条
@auth xuyd
@date 2024-05-02
//-->
<template>
  <div class="split-bar" :class="[position === 'left'? 'split-bar-left': 'split-bar-right']" @click="handleClick">
    <el-icon v-if="position === 'left'" :class="showBar? 'el-icon-arrow-left': 'el-icon-arrow-right'"/>
    <el-icon v-else :class="showBar? 'el-icon-arrow-right': 'el-icon-arrow-left'"/>
  </div>
</template>

<script>

export default {
  name: 'WbSplitBar',
  data() {
    return {
      showBar: this.value
    }
  },
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    position: {
      type: String,
      default: 'left',
    },
    value: Boolean
  },
  methods: {
    handleClick() {
      this.showBar = !this.showBar;
      this.$emit('change', this.showBar);
    }
  }

}
</script>

<style scoped lang="less">

@import '../../assets/css/variables.less';

.split-bar {
  display: flex;
  align-items: center;
  padding: 6px 2px;
  color: @dv_split_color;
  font-size: 12px;
  background-color: @dv_split_background;
  cursor: pointer;

  &:hover {
    color: @dv_split_active_color;
    background-color: @dv_split_active_background;
  }

  &.split-bar-left {
    border-left: 1px solid @dv_split_border;
  }

  &.split-bar-right {
    border-right: 1px solid @dv_split_border;
  }
}

</style>
